import request from "@/utils/request";

// 工单管理-常见问题类型-列表
export function commonQuestionType(data) {
  return request({
    url: "/admin/common_question_type",
    method: "get",
    params: data,
  });
}

// 工单管理-常见问题类型-添加
export function addCommonQuestionType(data) {
  return request({
      url: "/admin/common_question_type",
      method: "post",
      params: data
  });
}

// 工单管理-常见问题类型-删除
export function delCommonQuestionType(id) {
  return request({
      url: "/admin/common_question_type/" + id,
      method: "delete",
      params: id
  });
}

// 工单管理-常见问题类型-修改 - 提交
export function commitCommonQuestionType(data) {
  return request({
      url: "/admin/common_question_type/" + data.id,
      method: "put",
      params: data
  });
}

// 工单管理-常见问题类型-无分页列表
export function getCommonQuestionType(data) {
  return request({
      url: "/admin/get_common_question_type",
      method: "get",
      params: data
  });
}

// 工单管理-常见问题-列表
export function commonQuestion(data) {
  return request({
      url: "/admin/common_question",
      method: "get",
      params: data
  });
}

// 工单管理-常见问题-添加
export function commonQuestionPost(data) {
  return request({
      url: "/admin/common_question",
      method: "post",
      params: data
  });
}

// 工单管理-常见问题-修改 - 提交
export function commonQuestionPut(data) {
  return request({
      url: "/admin/common_question/" + data.id,
      method: "put",
      params: data
  });
}

// 工单管理-常见问题-删除
export function commonQuestionDel(id) {
  return request({
      url: "/admin/common_question/" + id,
      method: "delete",
      params: id
  });
}

// 工单管理-数据统计
export function dataAnalysis(data) {
  return request({
      url: "/admin/data_analysis",
      method: "post",
      data: data
  });
}